module.exports = __webpack_public_path__ + "static/media/laptop.3baf98c5.jpg";